import { openForbiddenModal } from "src/pages/Studies/states/studiesSlice";
import { IStandardApiResponse } from "src/pages/Studies/models/interfaces";
import { apiService } from "src/services";
import { getBearerToken } from "src/services/axiosInstance";
import { environment } from "src/config/environment";

export const getAllReports = async () => {
	return await apiService.get("sb-reports/");
};

export const getReportsDropdownData = async (values: any) => {
	return await apiService.get("search/dropdown", { ...values });
};

export const createNewReport = async (values: any) => {
	return await apiService.post("sb-reports/", { ...values });
};

export const editReport = async (values: any) => {
	return await apiService.put("sb-reports/", { ...values });
};

export const deleteReport = async (values: any) => {
	return await apiService.delete(`sb-reports/`, values, { withBody: true });
};

export const publishReport = async (values: any) => {
	return await apiService.post(`sb-reports/publish-report/${values?.report_iteration_id}`, {});
};

export const addCollaborators = async (values: any) => {
	return await apiService.post(`/sb-reports/collaborators`, { ...values });
};

export const getReportIterations = async (values: Record<string, unknown>) => {
	return await apiService.get<IStandardApiResponse<unknown[]>>(`/sb-reports/iterations`, { ...values });
};

export const getStreamSectionPreviewResponse = async (payload: any, userProfileId: string, userRole: string, abortController: AbortController, dispatch: any) => {
	const countWidgetStreamUrl = `${environment.REACT_APP_API_URL}stream/sb-reports/generate-report-section`;
	const token = await getBearerToken();
	const headers: Record<string, string> = {
		"Content-Type": "application/json",
		"profile-id": userProfileId,
		"role-id": userRole,
	};
	if (token) {
		headers.Authorization = `Bearer ${token}`;
	}
	const response = await fetch(countWidgetStreamUrl, {
		method: "POST",
		headers,
		credentials: "include",
		body: JSON.stringify({ ...payload }),
		signal: abortController?.signal,
	});

	if (response.status === 403) {
		const errorResponse = await response.json();
		dispatch(openForbiddenModal({ message: errorResponse?.detail?.message, type: errorResponse?.detail?.error_type }));
	}
	if (!response.ok) {
		throw new Error(`HTTP error! Status: ${response.status}`);
	}
	return response;
};

export const editReportStar = async (values: any) => {
	return await apiService.put(`sb-reports/star`, { ...values });
};

export const downloadReportFile = async (values: any) => {
	const { file_name, file_extension, report_iteration_id } = values;
	const downloadFileName = file_name.includes(".") ? file_name : `${file_name}.${file_extension}`;

	try {
		const response: any = await apiService.get("sb-reports/download-report-iteration", { report_iteration_id });
		const fileResponse = await fetch(response.data.url);
		if (fileResponse.ok) {
			const blob = await fileResponse.blob();
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			a.download = downloadFileName;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		} else {
			throw new Error("Failed to download file");
		}
	} catch (err) {
		console.error("Error downloading file: ", err);
		throw err;
	}
};
